<form [formGroup]="myForm" (submit)="myForm.valid && myForm.dirty && onSubmit()">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <span class="title dialog-title">Senha do usuário para acesso ao servidor ou Active Directory</span>
  </mat-toolbar>
  <div class="mat-white-bg mat-elevation-z2 flex-col align-between-stretch" matDialogContent>
    <div class="p-16 flex-col align-start-stretch">
      <div class="mb-16">
        <h3>
          Digite a nova senha que será utilizada no seu usuário do domínio.
        </h3>
        <div class="flex-col mt-16" style="font-size: 15px; gap: 8px;">
          <div class="flex-row" style="gap: 8px;">
            <b>Domínio:</b>
            <span>{{adDomain.domainName}}</span>
          </div>
          <div class="flex-row" style="gap: 8px;">
            <b>Login:</b>
            <span>{{adUser.login}}</span>
          </div>
        </div>
      </div>
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Senha</mat-label>
        <input matInput type="password" placeholder="Digite sua senha" [formControl]="adUserPassword">
        @if (adUserPassword.hasError('minlength')) {
          <mat-error>A senha deve conter pelo menos 8 caracteres.</mat-error>
        }
      </mat-form-field>
      @if (adPasswordWarning) {
        <div class="warn-A700-fg mb-10" style="font-size: 12px;">{{ adPasswordWarning }}</div>
      }
    </div>
  </div>
  <div class="flex-fill p-16 grey-50-bg border-top flex-row align-between-end" matDialogActions>
    <div>
      <button type="submit" mat-raised-button color="accent" aria-label="Salvar"
              [disabled]="myForm.pristine || !myForm.valid">Salvar
      </button>
    </div>
    <div>
      <button type="button" mat-raised-button color="primary" (click)="onCancel()">Cancelar</button>
    </div>
  </div>
</form>
